

























































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import CheckSheetItem from '@/components/CheckSheetItem.vue'
import { extend } from 'lodash'

interface LabelKeyPair {
  valueKey: string    // value object's nested key
  label: string       // display label
  type: string        // bool, or ... INPUT.type = number, text, email, phone
  col: number         // 0 = auto
}

@Component({
  components: {
    CheckSheetItem
  },
})
export default class CheckSheetGroupRow extends Vue {

  @Prop({
    required: true
  })
  private value: {[key: string]: any}

  @Prop({
    default: ''
  })
  private label!: string

  @Prop({
    default: () => [
      { valueKey: 'ok', label: 'OK', type: 'bool', col: 0 },
      { valueKey: 'not_good', label: 'Not Good', type: 'bool', col: 0 },
    ]
  })
  private conditionKeyPairs!: LabelKeyPair[]

  @Prop({
    default: () => [
      { valueKey: 'replaced', label: 'Replaced', type: 'bool', col: 0 },
      { valueKey: 'need_replacement', label: 'Need Replacement', type: 'bool', col: 0 },
    ]
  })
  private actionKeyPairs!: LabelKeyPair[]

  private conditionColumnClass(kp: LabelKeyPair) {
    if (kp.col === 0) {
      return `col-sm-${12 / this.conditionKeyPairs.length}`
    }
    return `col-sm-${kp.col}`
  }

  private actionColumnClass(kp: LabelKeyPair) {
    if (kp.col === 0) {
      return `col-sm-${12 / this.actionKeyPairs.length}`
    }
    return `col-sm-${kp.col}`
  }

  subItemChanged(keypair: LabelKeyPair, newValue: boolean) {
    const value = extend({}, this.value)
    value[keypair.valueKey] = newValue
    this.input(value)
  }

  subItemChangedText(keypair: LabelKeyPair, event: any) {
    const value = extend({}, this.value)
    value[keypair.valueKey] = event.target.value
    this.input(value)
  }

  @Emit()
  input(value: {}) { }
}
